<template>
    <div class="frame-container">
        <msg v-if="!show" type="error">
            您还未设置资格审查内容，请设置资格审查内容后访问此页面。
        </msg>
        <msg v-if="isShencha" type="warning">
          未开标无法进行审查
        </msg>
        <template v-if="show&&isShencha==false">
            <div v-if="showFrame" class="frame-view-left">
                <pdf :src="iframeSrc"></pdf>
            </div>
            <div :class="{'frame-view-right': showFrame}">
                <my-form  
                v-model="form"
                table
                label-width="0"
                @cancle="cancleHandler"
                :before-send="beforeSend"
                :submit-url="`${getGetters('bidUrl')}/Zbdl/zgsc/xingtai/edit.json`">
                    <el-form-item
                    class="table-full-row"
                    label-width="0"
                    prop="tableData"
                    :rules="[{validator:tableDataValidate, trigger:['blur','change']}]">
                        <table-shen-cha :data="form.tableData" @view="viewHandler" ref="table">
                            <el-table-column type="expand" slot="pre" fixed>
                                <template slot-scope="scope">
                                    <table class="table-inner-table">
                                        <tr v-for="(col, index) in nrlist" :key="index">
                                            <td>{{col.content}}</td>
                                            <td class="col-handle">
                                                <radio-adopt v-model="scope.row.$nr_col[index].shbj" :opinion.sync="scope.row.$nr_col[index].opinion"></radio-adopt>
                                            </td>                    
                                        </tr>
                                    </table>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column
                            v-for="(col, index) in nrlist"
                            :key="col.guid"
                            :label="col.content"
                            :min-width="160"
                            >
                                <template slot-scope="scope">
                                    <radio-adopt v-model="scope.row.$nr_col[index].shbj" :opinion.sync="scope.row.$nr_col[index].opinion"></radio-adopt>
                                </template>
                            </el-table-column> -->
                        </table-shen-cha>
                    </el-form-item>

                    <template slot="btn" slot-scope="scope">
                        <template v-if="showbutton">
                            <el-button
                            @click="scope.submitHandler"
                            type="primary"
                            icon="el-icon-circle-check">
                                保存
                            </el-button>

                            <el-button
                            @click="allPassHandler"
                            type="warning"
                            >
                                设为全部通过
                            </el-button>
                            <el-button
                            @click="cqwt()"
                            type="warning"
                            >
                                澄清问题
                            </el-button>
                            <!-- <my-btn type="new" @click="cqwt()">澄清问题</my-btn> -->
                        </template>

                        <el-button icon="el-icon-circle-close" @click="scope.cancleHandler">取消</el-button>
                    </template>
                </my-form>
            </div>

        </template>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'

import Msg from './components/msg'
import TableShenCha from './components/table-shen-cha'
import RadioAdopt from './components/radio-adopt'

export default {
    mixins: [ FORM_PAGE_MIXIN ],
    components: { Msg, TableShenCha, RadioAdopt },
    data: () => ({
        form: {
            data: [],
            tableData: []
        },
        showbutton: false,
        show: true,
        isShencha:false,
        nrlist: [],
        showFrame: false,
        iframeSrc: '',
       
    }),
    methods: {
        cqwt() {
            this.goto({
                path: './cqwtlist',
                query: {
                  bdcode:this.getQuery('bdcode')
                }             
            });
        },
        beforeSend(send) {
            var formData = []
            this.form.tableData.forEach(row => {
                row.$nr_col.forEach(col => {
                    var obj = {
                        tbdwcode: row.tbdwcode,
                        tbdwname: row.tbdwname,
                        nrguid: col.$self.guid,
                        zbprocode: col.$self.zbprocode,
                        content: col.$self.content,
                        condition: col.$self.condition,
                        bdcode: this.detailExtra.bdcode,
                        shbj: col.shbj,
                        opinion: col.opinion,
                    };

                    formData.push(obj);
                });
            });

            this.form.data = JSON.stringify(formData);

            send();
        },
        allPassHandler() {
            this.form.tableData.forEach((row, index) => {
                var clone_row = row;
                row.$nr_col.forEach(item => {
                    item.shbj = '1';
                });
 
                // this.tableData.splice(index, 1, clone_row);
            });
        },
        tableDataValidate(rule, value, callback) {
            if(value.some(row => {
                return row.$nr_col.some(col => {
                    return (col.shbj === '3' && !col.opinion);
                })
            })) {
                callback(new Error('存在审核不通过但未填写原因的项'));
            } else if(value.some(row => {
                return row.$nr_col.some(col => {
                    return !col.shbj;
                })
            })) {
                callback(new Error('存在未选择审核结果的项'));
            } else {
                callback();
            };
        },
        initTableData(listData, nrlist) {
            var tableData = [];
            listData.push.apply(tableData, listData);
            tableData.forEach(row => {
                row.$nr_col = [];
                nrlist.forEach(col => {
                    row.$nr_col.push({
                        shbj: '',
                        opinion: '',
                        $self: col
                    });
                });
            });
            return tableData;
        },
        viewHandler(src) {
            this.iframeSrc = src;
            this.showFrame = true;
        }
    },
    created() {
        this.jspInit(`${this.getGetters('bidUrl')}/Zbdl/zgsc/xingtai/editinit.json`, 
        {bdcode:this.getQuery('bdcode')}, 
        data => {
            this.jspDataInit(data, ['showbutton', 'show', 'nrlist']);

            if(data.show) {
                if(data.listData.length==0) {
                    this.isShencha=true
                }
                console.log(data.listData)
                console.log(this.isShencha)
                this.form.tableData = this.initTableData(data.listData || [], data.nrlist || []);
            };
        });
    }
}
</script>
             
<style scoped lang="scss">
    @import '@css/var.scss';
    .table-inner-table{width:100%; table-layout:fixed;
        td{padding:0 1em;}
        .col-handle{width:200px}
    }

    .frame-container{ width:100%; height:100%; position:relative;
        .frame-view-left, .frame-view-right{position:absolute; top:0; bottom:0;}
        .frame-view-left{left:0; right:50%; border:1px solid #EBEEF5; box-sizing:border-box;}
        .frame-view-right{left:50%; right:0; overflow:auto;}
    }
    /deep/ .table-view .el-form-item:not(.btn-row) .el-form-item__content .el-form-item__error {
            bottom: -22px!important;
    }
</style>
